export const messageConversationCss = `.message-item ol,
.message-item ul {
  padding-left: 1.5em;
}
.message-item ol > li,
.message-item ul > li {
  list-style-type: none;
}
.message-item ul > li::before {
  content: "\u2022";
}
.message-item ul[data-checked="true"],
.message-item ul[data-checked="false"] {
  pointer-events: none;
}
.message-item ul[data-checked="true"] > li *,
.message-item ul[data-checked="false"] > li * {
  pointer-events: all;
}
.message-item ul[data-checked="true"] > li::before,
.message-item ul[data-checked="false"] > li::before {
  color: #777;
  cursor: pointer;
  pointer-events: all;
}
.message-item ul[data-checked="true"] > li::before {
  content: "\u2611";
}
.message-item ul[data-checked="false"] > li::before {
  content: "\u2610";
}
.message-item li::before {
  display: inline-block;
  white-space: nowrap;
  width: 1.2em;
}
.message-item li:not(.ql-direction-rtl)::before {
  margin-left: -1.5em;
  margin-right: 0.3em;
  text-align: right;
}
.message-item li.ql-direction-rtl::before {
  margin-left: 0.3em;
  margin-right: -1.5em;
}
.message-item ol li:not(.ql-direction-rtl),
.message-item ul li:not(.ql-direction-rtl) {
  padding-left: 1.5em;
}
.message-item ol li.ql-direction-rtl,
.message-item ul li.ql-direction-rtl {
  padding-right: 1.5em;
}
.message-item ol li {
  counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
  counter-increment: list-0;
}
.message-item ol li:before {
  content: counter(list-0, decimal) ". ";
}
.message-item ol li.ql-indent-1 {
  counter-increment: list-1;
}
.message-item ol li.ql-indent-1:before {
  content: counter(list-1, lower-alpha) ". ";
}
.message-item ol li.ql-indent-1 {
  counter-reset: list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
}
.message-item ol li.ql-indent-2 {
  counter-increment: list-2;
}
.message-item ol li.ql-indent-2:before {
  content: counter(list-2, lower-roman) ". ";
}
.message-item ol li.ql-indent-2 {
  counter-reset: list-3 list-4 list-5 list-6 list-7 list-8 list-9;
}
.message-item ol li.ql-indent-3 {
  counter-increment: list-3;
}
.message-item ol li.ql-indent-3:before {
  content: counter(list-3, decimal) ". ";
}
.message-item ol li.ql-indent-3 {
  counter-reset: list-4 list-5 list-6 list-7 list-8 list-9;
}
.message-item ol li.ql-indent-4 {
  counter-increment: list-4;
}
.message-item ol li.ql-indent-4:before {
  content: counter(list-4, lower-alpha) ". ";
}
.message-item ol li.ql-indent-4 {
  counter-reset: list-5 list-6 list-7 list-8 list-9;
}
.message-item ol li.ql-indent-5 {
  counter-increment: list-5;
}
.message-item ol li.ql-indent-5:before {
  content: counter(list-5, lower-roman) ". ";
}
.message-item ol li.ql-indent-5 {
  counter-reset: list-6 list-7 list-8 list-9;
}
.message-item ol li.ql-indent-6 {
  counter-increment: list-6;
}
.message-item ol li.ql-indent-6:before {
  content: counter(list-6, decimal) ". ";
}
.message-item ol li.ql-indent-6 {
  counter-reset: list-7 list-8 list-9;
}
.message-item ol li.ql-indent-7 {
  counter-increment: list-7;
}
.message-item ol li.ql-indent-7:before {
  content: counter(list-7, lower-alpha) ". ";
}
.message-item ol li.ql-indent-7 {
  counter-reset: list-8 list-9;
}
.message-item ol li.ql-indent-8 {
  counter-increment: list-8;
}
.message-item ol li.ql-indent-8:before {
  content: counter(list-8, lower-roman) ". ";
}
.message-item ol li.ql-indent-8 {
  counter-reset: list-9;
}
.message-item ol li.ql-indent-9 {
  counter-increment: list-9;
}
.message-item ol li.ql-indent-9:before {
  content: counter(list-9, decimal) ". ";
}
.message-item .ql-indent-1:not(.ql-direction-rtl) {
  padding-left: 3em;
}
.message-item li.ql-indent-1:not(.ql-direction-rtl) {
  padding-left: 4.5em;
}
.message-item .ql-indent-1.ql-direction-rtl.ql-align-right {
  padding-right: 3em;
}
.message-item li.ql-indent-1.ql-direction-rtl.ql-align-right {
  padding-right: 4.5em;
}
.message-item .ql-indent-2:not(.ql-direction-rtl) {
  padding-left: 6em;
}
.message-item li.ql-indent-2:not(.ql-direction-rtl) {
  padding-left: 7.5em;
}
.message-item .ql-indent-2.ql-direction-rtl.ql-align-right {
  padding-right: 6em;
}
.message-item li.ql-indent-2.ql-direction-rtl.ql-align-right {
  padding-right: 7.5em;
}
.message-item .ql-indent-3:not(.ql-direction-rtl) {
  padding-left: 9em;
}
.message-item li.ql-indent-3:not(.ql-direction-rtl) {
  padding-left: 10.5em;
}
.message-item .ql-indent-3.ql-direction-rtl.ql-align-right {
  padding-right: 9em;
}
.message-item li.ql-indent-3.ql-direction-rtl.ql-align-right {
  padding-right: 10.5em;
}
.message-item .ql-indent-4:not(.ql-direction-rtl) {
  padding-left: 12em;
}
.message-item li.ql-indent-4:not(.ql-direction-rtl) {
  padding-left: 13.5em;
}
.message-item .ql-indent-4.ql-direction-rtl.ql-align-right {
  padding-right: 12em;
}
.message-item li.ql-indent-4.ql-direction-rtl.ql-align-right {
  padding-right: 13.5em;
}
.message-item .ql-indent-5:not(.ql-direction-rtl) {
  padding-left: 15em;
}
.message-item li.ql-indent-5:not(.ql-direction-rtl) {
  padding-left: 16.5em;
}
.message-item .ql-indent-5.ql-direction-rtl.ql-align-right {
  padding-right: 15em;
}
.message-item li.ql-indent-5.ql-direction-rtl.ql-align-right {
  padding-right: 16.5em;
}
.message-item .ql-indent-6:not(.ql-direction-rtl) {
  padding-left: 18em;
}
.message-item li.ql-indent-6:not(.ql-direction-rtl) {
  padding-left: 19.5em;
}
.message-item .ql-indent-6.ql-direction-rtl.ql-align-right {
  padding-right: 18em;
}
.message-item li.ql-indent-6.ql-direction-rtl.ql-align-right {
  padding-right: 19.5em;
}
.message-item .ql-indent-7:not(.ql-direction-rtl) {
  padding-left: 21em;
}
.message-item li.ql-indent-7:not(.ql-direction-rtl) {
  padding-left: 22.5em;
}
.message-item .ql-indent-7.ql-direction-rtl.ql-align-right {
  padding-right: 21em;
}
.message-item li.ql-indent-7.ql-direction-rtl.ql-align-right {
  padding-right: 22.5em;
}
.message-item .ql-indent-8:not(.ql-direction-rtl) {
  padding-left: 24em;
}
.message-item li.ql-indent-8:not(.ql-direction-rtl) {
  padding-left: 25.5em;
}
.message-item .ql-indent-8.ql-direction-rtl.ql-align-right {
  padding-right: 24em;
}
.message-item li.ql-indent-8.ql-direction-rtl.ql-align-right {
  padding-right: 25.5em;
}
.message-item .ql-indent-9:not(.ql-direction-rtl) {
  padding-left: 27em;
}
.message-item li.ql-indent-9:not(.ql-direction-rtl) {
  padding-left: 28.5em;
}
.message-item .ql-indent-9.ql-direction-rtl.ql-align-right {
  padding-right: 27em;
}
.message-item li.ql-indent-9.ql-direction-rtl.ql-align-right {
  padding-right: 28.5em;
}
.message-item .ql-video {
  display: block;
  max-width: 100%;
}
.message-item .ql-video.ql-align-center {
  margin: 0 auto;
}
.message-item .ql-video.ql-align-right {
  margin: 0 0 0 auto;
}
.message-item .ql-bg-black {
  background-color: #000;
}
.message-item .ql-bg-red {
  background-color: #e60000;
}
.message-item .ql-bg-orange {
  background-color: #f90;
}
.message-item .ql-bg-yellow {
  background-color: #ff0;
}
.message-item .ql-bg-green {
  background-color: #008a00;
}
.message-item .ql-bg-blue {
  background-color: #06c;
}
.message-item .ql-bg-purple {
  background-color: #93f;
}
.message-item .ql-color-white {
  color: #fff;
}
.message-item .ql-color-red {
  color: #e60000;
}
.message-item .ql-color-orange {
  color: #f90;
}
.message-item .ql-color-yellow {
  color: #ff0;
}
.message-item .ql-color-green {
  color: #008a00;
}
.message-item .ql-color-blue {
  color: #06c;
}
.message-item .ql-color-purple {
  color: #93f;
}
.message-item .ql-font-serif {
  font-family: Georgia, Times New Roman, serif;
}
.message-item .ql-font-monospace {
  font-family: Monaco, Courier New, monospace;
}
.message-item .ql-size-small {
  font-size: 0.75em;
}
.message-item .ql-size-large {
  font-size: 1.5em;
}
.message-item .ql-size-huge {
  font-size: 2.5em;
}
.message-item .ql-direction-rtl {
  direction: rtl;
  text-align: inherit;
}
.message-item .ql-align-center {
  text-align: center;
}
.message-item .ql-align-justify {
  text-align: justify;
}
.message-item .ql-align-right {
  text-align: right;
}
.message-item.ql-blank::before {
  color: rgba(0, 0, 0, 0.6);
  content: attr(data-placeholder);
  font-style: italic;
  left: 15px;
  pointer-events: none;
  position: absolute;
  right: 15px;
}

.message-item a {
  color: rgb(10, 90, 245);
  text-decoration-line: underline;
}
.message-item ol.custom-numbered li.counter-init {
  counter-increment: list-0 !important;
  counter-reset: list-1 !important;
}

.message-item .custom-numbered li {
  counter-increment: list-0 !important;
  counter-reset: list-1 !important;
}
.message-item .custom-numbered li:before {
  content: counter(list-0, decimal) ". " !important;
}

.message-item .custom-numbered li.ql-indent-1 {
  counter-increment: list-1 !important;
  counter-reset: list-2 !important;
}
.message-item .custom-numbered li.ql-indent-1:before {
  content: counter(list-0, decimal) "." counter(list-1, decimal) ". " !important;
  margin-left: -25px !important;
  margin-right: 9px !important;
}

.message-item .custom-numbered li.ql-indent-2 {
  counter-increment: list-2 !important;
  counter-reset: list-3 !important;
}
.message-item .custom-numbered li.ql-indent-2:before {
  content: counter(list-0, decimal) "." counter(list-1, decimal) "."
    counter(list-2, decimal) ". " !important;
  margin-left: -40px !important;
  margin-right: 24px !important;
}

.message-item .custom-numbered li.ql-indent-3 {
  counter-increment: list-3 !important;
  counter-reset: list-4 !important;
}
.message-item .custom-numbered li.ql-indent-3:before {
  content: counter(list-0) "." counter(list-1) "." counter(list-2) "."
    counter(list-3) ". " !important;
  margin-left: -47px !important;
  margin-right: 32px !important;
}

.message-item .custom-numbered li.ql-indent-4 {
  counter-increment: list-4 !important;
  counter-reset: list-5 !important;
}
.message-item .custom-numbered li.ql-indent-4:before {
  content: counter(list-0) "." counter(list-1) "." counter(list-2) "."
    counter(list-3) "." counter(list-4) ". " !important;
  margin-left: -58px !important;
  margin-right: 42px !important;
}
`
